/**
 * useTaskArtifacts - Content, deliverables, inputs, and attachments changes
 */

import { useTaskNotes } from './useTaskNotes';
import { useQuickNotes } from './useQuickNotes';
import { useMissionDocs } from './useMissionDocs';
import { useMissionProgress } from './useMissionProgress';
import { useAttachedDocs } from './useAttachedDocs';
import { useTaskLists } from './useTaskLists';

export function useTaskArtifacts(localSprint, setLocalSprint, recordAction) {
  const notes = useTaskNotes(localSprint, setLocalSprint, recordAction);
  const quickNotes = useQuickNotes(localSprint, setLocalSprint, recordAction);
  const missionDocs = useMissionDocs(localSprint, setLocalSprint, recordAction);
  const progress = useMissionProgress(setLocalSprint);
  const attached = useAttachedDocs(localSprint, setLocalSprint, recordAction);
  const lists = useTaskLists(localSprint, setLocalSprint, recordAction);

  return {
    handleNotesChange: notes.handleNotesChange,
    handleInternalNotesChange: notes.handleInternalNotesChange,
    handleMissionDocChange: missionDocs.handleMissionDocChange,
    handleMissionDocTicksChange: progress.handleMissionDocTicksChange,
    handleMissionDocFilesChange: progress.handleMissionDocFilesChange,
    handleMissionVariablesChange: progress.handleMissionVariablesChange,
    handleAttachedDocsChange: attached.handleAttachedDocsChange,
    handleQuickNotesChange: quickNotes.handleQuickNotesChange,
    handleMissionDocsMigrated: attached.handleMissionDocsMigrated,
    handleClearMissionLegacyNotes: missionDocs.handleClearMissionLegacyNotes,
    handleDeliverablesChange: lists.handleDeliverablesChange,
    handleInputsChange: lists.handleInputsChange,
    handleAttachmentCountChange: lists.handleAttachmentCountChange,
  };
}

export default useTaskArtifacts;
